<template>
  <div class="bdy_top">
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->
    <div class="table_list">
      <button class="table_button" @click="pushupdate">新增门店</button>
      <div class="table_list_button">
        <h1>门店列表</h1>
        <!-- <el-button type="primary" style="background:#1890ff;" >
          <i class="el-icon-plus" style="margin-right:10px"></i>
          新增
        </el-button>-->
      </div>
      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="店铺名称">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺地址">
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式">
          <template slot-scope="scope">
            <span>{{ scope.row.contact_number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" @click="getDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageSize"
        class="pagination_em"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shop',
  components: {},
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      tableData: [
      ],
      total: 0,
      page_no: 0,
    };
  },

  methods: {
    getList() {
      this.listloading = true;
      const url = this.$userList.user_restaurant_list + `/${this.page_no}/10`;
      this.$http.get(url).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          console.log(res);
          this.total = res.data.count;
          this.tableData = res.data.items;
        } else {
          //res.message && this.$alert(res.message);
        }
      });
    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    handleEdit(index) {
      console.log(index);
      localStorage.setItem('basics_min', JSON.stringify(index));
      this.$router.push({ path: '/shop/basics' });
    },
    pushupdate() {
      this.$router.push({ path: '/shop/basic/update' });
    },

    getDelete(id) {
      this.$confirm('此操作将删除店铺, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const url = this.$userList.user_restaurants + '/' + id;
        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.getList();
          } else {
            res.message && this.$alert(res.message);
          }
          console.log(res);
        });
      });
    },
  },

  created() {
    this.getList();
  },
};
</script>
<style scoped>
.bdy_top {
  width: 100%;
  height: auto;
}

.rili {
  width: 100%;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  font-size: 14px;
}
.rili .ul {
  width: 100%;
  border-top: solid 1px #eee;
  display: flex;
  justify-content: space-between;
  border-left: solid 1px #eee;
}
.rili .ul li {
  flex: 1;
  border-right: solid 1px #eee;
  min-height: 77px;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 10px;
  padding-top: 30px;
}
.rili .ul li span {
  position: absolute;
  right: 10px;
  top: 5px;
}
.rili .ul:last-child li {
  border-bottom: solid 1px #eee;
}
.back_r {
  display: flex;
}
.back_r li {
  flex: 1;
  text-align: end;
}
.prev,
.next {
  color: #c0c4cc;
}
.clickDate {
  background: #f2f8fe;
  color: #409eff;
}
.ceshi {
  flex: 1;
  height: 20px;
  opacity: 0.5;
  text-align: center;
}
.leftClass {
  box-sizing: border-box;
  margin-left: 10px;
  border-radius: 5px 0 0 5px;
}
.rightClass {
  box-sizing: border-box;
  margin-right: 10px;
  border-radius: 0 5px 5px 0;
}
.table_list {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.table_list_button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-table__body,
.el-table__header {
  width: 100% !important;
}
table,
tbody,
thead {
  width: 100% !important;
}
colgroup {
  position: absolute;
  width: 100% !important;
  display: flex;
}
col {
  flex: 1;
  text-align: center;
}
.table_button {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  background: #409eff;
  color: #fff;
}
</style>
